import { catchError } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { CustomPresetColumnsReportService } from './service/custom-preset-columns-report.component.service';
import { presetInterface } from 'src/app/util/interfaces/preset';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'register-form-custom-preset-columns-report',
	templateUrl: './custom-preset-columns-report.component.html',
	styleUrls: ['./custom-preset-columns-report.component.scss'],
})
export class CustomPresetColumnsReportComponent implements OnInit {
	labels: LabelsInterface = {
		lbl_geral_selecione: '',
		lbl_cmdb: '',
		lbl_status_estoque: '',
		lbl_chamado: '',
		lbl_geral_buscar: '',
		lbl_geral_observacoes: '',
		lbl_geral_novo: '',
		lbl_geral_salvar: '',
		lbl_geral_confirmar: '',
		lbl_geral_excluir: '',
		lbl_selecione_tipo_relatorio_deseja_usar_predefinicoes: '',
		lbl_nenhuma_predefinicao_com_esse_tipo: '',
		lbl_nome_predefinicao: '',
		lbl_an_errour_occour: '',
		lbl_salvo_com_sucesso: '',
		lbl_successful_updated: '',
		lbl_clique_confirmar_acao: '',
		lbl_erro_nome_ja_existente: '',
		lbl_por_favor_informe_nome: '',
		lbl_geral_selecione_coluna: '',
		lbl_geral_desativado_com_sucesso: '',
		lbl_geral_selecione_preset_para_desativa_lo: '',
		lbl_selecione_coluna_exibir_relatorio: '',
		lbl_report_columns_default: '',
		lbl_tipo_relatorio: '',
	};

	constructor(
		private notification: NotificationService,
		private LabelsService: LabelsService,
		private customPresetService: CustomPresetColumnsReportService
	) {}

	isLoadingPresets = true;
	isLoadingLabels = true;
	isLoadingMessageNotFoundPresets = false;
	isLoadingTypeColumns = false;
	isDeletingPreset = false;
	isUpdatingPreset = false;

	customPresetInterface = {
		id: '-1',
		typePreset: null,
		namePreset: '',
		notes: '',
		active: '',
		columns: [],
	};

	configurationColumns: genericFormInterface[] = [
		{
			name: 'hideColumns',
			label: 'lbl_selecione_coluna_exibir_relatorio',
			inputType: 'multi-select',
			values: [''],
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
			filterOutItem: [''],
		},
	];

	presetList: presetInterface[] = [];
	listPresetsIAC: iacOptionInterface[] = [];
	setInputText = '';
	clearValuesPreset = false;
	placeholderPreset = '';

	ngOnInit() {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});
	}

	getPresetsByType(type: string) {
		this.setInputText = '';
		this.customPresetInterface.namePreset = '';
		this.customPresetInterface.notes = '';

		this.isLoadingTypeColumns = true;
		(this.customPresetService.getPresetByType(type).subscribe((presets) => {
			this.configurationColumns[0].values = [];
			this.configurationColumns[0].rawValues = [];
			this.configurationColumns[0].items = [];

			//Todas as colunas por type
			this.customPresetService.getAllColumnsByType(type).subscribe({
				next: (columns) => {
					for (const key of Object.keys(columns)) {
						const newItem: genericFormI['items'] = {
							name: key,
							label: columns[key],
							values: [key],
							rawValues: [key],
						};
						this.configurationColumns[0].items.push(newItem);
					}
				},
				complete: () => {
					this.isLoadingTypeColumns = false;
				},
			});

			this.presetList = [];
			this.listPresetsIAC = [];
			this.presetList = presets;

			for (const item of this.presetList) {
				const newIacOptionLocation: iacOptionInterface = {
					name: item.namePreset,
					value: item.id,
					// "commonGroup": item.active === 1 ? this.labels.lbl_geral_ativo : this.labels.lbl_status_desativado
				};
				this.listPresetsIAC.push(newIacOptionLocation);
			}
			this.isLoadingPresets = false;
		}),
			(errorRes) => {
				this.notification.setNotificationMessage(this.labels.lbl_an_errour_occour);
			});
	}

	// Coleta o a preset para form
	getPreset(idPreset: string) {
		this.isLoadingTypeColumns = true;
		this.setInputText = '';
		this.customPresetInterface.namePreset = '';
		this.customPresetInterface.notes = '';
		this.configurationColumns[0].rawValues = [];
		this.configurationColumns[0].values = [];
		// this.configurationColumns[0].items = [];

		this.customPresetService.getPresetByID(idPreset).subscribe((presetResp) => {
			this.customPresetInterface = presetResp;

			//Colunas que vão serem ocultadas
			let arrayItens = [];
			arrayItens = presetResp.columns;

			//Todas as colunas por type
			// this.customPresetService.getAllColumnsByType(this.customPresetInterface.typePreset).subscribe((columns) => {
			//   columns.forEach(column => {
			//     let newItem: genericFormInterface['items'][number] = {
			//       name: column.name,
			//       label: column.label,
			//       values: [column.name],
			//       rawValues: [column.name],
			//     };
			//     this.configurationColumns[0].items.push(newItem);

			//     if(arrayItens.includes(column.name)) {
			//       this.configurationColumns[0].values.push(newItem);
			//       this.configurationColumns[0].rawValues.push(column.name);
			//     }
			//   });

			//   // this.configurationColumns[0].rawValues = this.configurationColumns[0].rawValues.filter(value => Object.keys(value).length !== 0);
			//   // this.configurationColumns[0].values = this.configurationColumns[0].values.filter(value => Object.keys(value).length !== 0);

			//   this.isLoadingTypeColumns = false;
			// });
			for (const column of this.configurationColumns[0].items) {
				if (arrayItens.includes(column.values[0])) {
					this.configurationColumns[0].values.push(column);
					this.configurationColumns[0].rawValues.push(column.rawValues[0]);
				}
			}
			this.isLoadingTypeColumns = false;
		});
	}

	newPreset() {
		this.clearValuesPreset = true;
		setTimeout(() => {
			this.clearValuesPreset = false;
		}, 1);

		this.setInputText = '';

		this.customPresetInterface = {
			id: '',
			typePreset: this.customPresetInterface.typePreset,
			namePreset: '',
			notes: '',
			active: '',
			columns: [],
		};

		this.configurationColumns[0] = {
			name: 'hideColumns',
			label: 'lbl_geral_selecione_coluna',
			inputType: 'multi-select',
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			values: [],
			rawValues: [],
			filterOutItem: [''],
		};

		// this.configurationColumns[0].values = [];
		// this.configurationColumns[0].rawValues = [];
		// this.configurationColumns[0].items = [];
		// this.listPresetsIAC = [];
		// this.presetList = [];
	}

	savePreset() {
		if (this.isUpdatingPreset || this.isDeletingPreset) return;
		this.isUpdatingPreset = true;

		const configurationForm: genericFormI[] = JSON.parse(JSON.stringify(this.configurationColumns));

		// for(let i = 0; i < configurationForm[0].items.length; i++) {
		//   for(let j = 0; j < configurationForm[0].values.length; j++) {
		//     if(configurationForm[0].values[j].name == configurationForm[0].items[i].name) {
		//       configurationForm[0].items.splice(i,1);
		//     }
		//   }
		// }

		// let columns = [];
		// configurationForm[0].values.forEach(column => {
		//   columns.push(column.name)
		// })

		this.customPresetInterface.columns = this.configurationColumns[0].rawValues;

		if (this.customPresetInterface.id === '') {
			this.customPresetService.postPreset(this.customPresetInterface).subscribe((presetResp) => {
				if (presetResp.status === 'error') {
					return this.notification.setNotificationMessage(this.labels.lbl_erro_nome_ja_existente);
				} else {
					this.reloadIacOptionPresets();
					this.notification.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
					this.customPresetInterface.id = presetResp.id;
				}
				this.isUpdatingPreset = false;
			});
		} else {
			if (this.customPresetInterface.id || '') {
				this.customPresetService.putPreset(this.customPresetInterface).subscribe((presetResp) => {
					if (presetResp.status === 'error') {
						return this.notification.setNotificationMessage(this.labels.lbl_erro_nome_ja_existente);
					} else {
						this.reloadIacOptionPresets();
						this.notification.setNotificationMessage(this.labels.lbl_successful_updated);
						this.isUpdatingPreset = false;
					}
				});
			}
		}
	}

	validateForm() {
		if (this.isUpdatingPreset || this.isDeletingPreset) return;

		if (this.customPresetInterface.namePreset === '') {
			this.notification.setNotificationMessage(this.labels.lbl_por_favor_informe_nome);
			return false;
		}

		if (this.configurationColumns[0].rawValues.length === 0) {
			this.notification.setNotificationMessage(this.labels.lbl_geral_selecione_coluna);
			return false;
		} else {
			this.savePreset();
		}
	}

	deletePreset(id: string) {
		if (this.isDeletingPreset || this.isUpdatingPreset) return;
		this.isDeletingPreset = true;

		if (id) {
			this.customPresetService.inactivePreset(id).subscribe((data) => {
				this.getPresetsByType(this.customPresetInterface.typePreset);
				// this.isButtonVisible = 0;
				this.newPreset();
				this.configurationColumns[0].values = [];
				this.configurationColumns[0].rawValues = [];
				this.configurationColumns[0].items = [];
				this.notification.setNotificationMessage(this.labels.lbl_geral_desativado_com_sucesso);
				this.isDeletingPreset = false;
			});
		}
	}

	reloadIacOptionPresets() {
		this.customPresetService.getPresetByType(this.customPresetInterface.typePreset).subscribe((presets) => {
			this.presetList = [];
			this.listPresetsIAC = [];
			this.presetList = presets;
			for (const item of this.presetList) {
				const newIacOptionLocation: iacOptionInterface = {
					name: item.namePreset,
					value: item.id,
					// "commonGroup": item.active === 1 ? this.labels.lbl_geral_ativo : this.labels.lbl_status_desativado
				};
				this.listPresetsIAC.push(newIacOptionLocation);
			}
		});
	}

	confirmButton(elementReference: HTMLElement): void {
		if (!this.customPresetInterface.id) {
			return this.notification.setNotificationMessage(this.labels.lbl_geral_selecione_preset_para_desativa_lo);
		}
		this.notification.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirm');
		setTimeout(() => {
			elementReference.classList.remove('confirm');
		}, 5000);
	}
}
